/**
* Component NavLink
*
* Link to navigate at the top of the page
*
* Props : 
* - text (String) : text on the button
* - url (String) : url on the new page
* - SubLink (String) : optional url lists display under an element
* 
*/

<template>
  <header class="nav-item">
  <li >
    <a :href="url" class="nav-link">
      {{ text }}
    </a>
    <!-- Sous-menu -->
    <ul v-if="subLinks && subLinks.length" class="submenu"> <!-- Look is the "sublink" exist and if the elements is more the 0-->
      <li v-for="(subLink, index) in subLinks" :key="index" class="submenu-item">
        <a :href="subLink.url" class="submenu-link">{{ subLink.text }}</a>
      </li>
    </ul>
  </li>
</header>
</template>

<script>
export default {
  name: 'NavLink',
  props: {
    url: String,
    text: String,
    subLinks: {
      type: Array,
      default: () => [], // By default no sublink
    },
  },
};
</script>


<style lang="scss">
@import "../assets//styles/variables";

.nav-link {

  text-decoration: none;
  transition: all 0.3s ease;
}
.nav-link:hover {
  color: $third-color ;
}
.nav-item {
  position: relative;
  
}

a {
    color: inherit;
    text-decoration: none;
  }

</style>